import { NgModule } from '@angular/core';

import { FilterHTMLPipe } from './filter-html.pipe';
import { SafeResourcePipe } from './safe-resource.pipe';

@NgModule({
    declarations: [
        SafeResourcePipe,
        FilterHTMLPipe,
    ],
    exports: [
        SafeResourcePipe,
        FilterHTMLPipe,
    ],
})
export class PipeModule {
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/pipes/pipe.module.ts